<template>
  <div>
    <form @keyup.enter="filter()" @submit.prevent>
      <div class="row pt-3">
        <div class="col-md-4">
          <text-input v-model="searchForm.search" placeholder="Pesquisar" />
        </div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn btn-sm btn-primary mr-3"
            @click="showFilters = !showFilters"
          >
            <i class="fas fa-filter" /> Mais Filtros
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="filter()"
          >
            <i class="fas fa-search" /> Pesquisar
          </button>
        </div>
      </div>
      <b-collapse v-model="showFilters">
        <b-row>
          <b-col cols="2" class="mt-3" align-self="center">
            <b-button @click="clear()" class="x-small" size="sm">
              <i class="fas fa-times" /> Limpar Filtro
            </b-button>
          </b-col>
          <b-col cols="2">
            <date-input
              v-model="searchForm.due_date_start"
              alias="Vencimento de"
            />
          </b-col>
          <b-col cols="2">
            <date-input
              v-model="searchForm.due_date_end"
              alias="Vencimento até"
            />
          </b-col>
          <b-col align-self="center">
            <b-form-checkbox
              class="d-block d-md-inline"
              switch
              inline
              @change="filter()"
              :value="'o'"
              :unchecked-value="''"
              v-model="searchForm.status"
            >
              <small>Em Aberto</small>
            </b-form-checkbox>
            <b-form-checkbox
              class="d-block d-md-inline"
              switch
              inline
              @change="filter()"
              :value="'p'"
              :unchecked-value="''"
              v-model="searchForm.status"
            >
              <small>Pagos</small>
            </b-form-checkbox>
            <b-form-checkbox
              class="d-block d-md-inline"
              switch
              inline
              @change="filter()"
              :value="'c'"
              :unchecked-value="''"
              v-model="searchForm.status"
            >
              <small>Cancelados</small>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-collapse>
    </form>
  </div>
</template>

<script>
export default {
  components: {},

  data: function () {
    return {
      showFilters: false,
      searchForm: {
        search: null,
        due_date_start: null,
        due_date_end: null,
        status: ["o"],
      },
    };
  },

  watch: {
    searchForm: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.$emit("input", this.searchForm);
      },
    },
  },

  methods: {
    clear() {
      (this.searchForm.search = null),
        (this.searchForm.due_date_start = null),
        (this.searchForm.due_date_end = null),
        (this.searchForm.status = ["o"]),
        this.$emit("filter");
    },

    filter() {
      this.$emit("filter");
    },
  },
};
</script>

<style>
</style>
